import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import User, { ChimeraMeUser } from '@/models/user/user.model';
import { redirectToUnauthorized } from '@/utils/services/accounts';

// initial state
// eslint-disable-next-line unicorn/no-useless-undefined
export const meAtom = atomWithStorage<ChimeraMeUser | undefined>('meUser', undefined);

export const authorizedChimeraAtom = atom<boolean>((get): boolean => {
  const meUser = get(meAtom);
  return !!meUser && User.authorizeChimera(meUser, () => {redirectToUnauthorized();});
});
